import React, {Component} from 'react';
import { Form, Icon, Input, Button} from 'antd';
import {Link, Redirect } from 'react-router-dom';
import { Row, Col, message, Spin } from 'antd';

import { login, agregar_titular_comite } from '../utils/JWTAuth';

let linkRegistro, state;

const success = (messages) => {
    message.success(messages);
  };
  
  const error = (messages) => {
    message.error(messages);
  };
  
  const warning = (messages) => {
    message.warning(messages);
  };

class FormLogin extends Component{

  constructor(props){
    super(props);

    state = this;

    this.state = {
      comite : 0,
      nombre_comite : 'Comités',
      loading : false
    }
    
  }

  componentDidMount(){
    switch(this.props.match.params.num_comite){
      case '1': this.setState({nombre_comite:'Comité de Seguridad Vial'}); break;
      case '2': this.setState({nombre_comite:'Comité de Prevención y Combate al Delito'}); break;
      case '3': this.setState({nombre_comite:'Comité de Movilidad'}); break;
      case '4': this.setState({nombre_comite:'Comité Ferroviario'}); break;
      case '5': this.setState({nombre_comite:'Comité Jurídico'}); break;
      case '6': this.setState({nombre_comite:'Comité Técnico'}); break;
      default:  break;
  }
}


    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
          if (!err) {

            state.setState({
              loading: true
            });
            
            let agregar_comite = {
                codigo: values.codigo,
                comite: this.props.match.params.num_comite
            }
            
            delete values.codigo;
            

           login(values).then(data=>{

            state.setState({
              loading: false
            });

switch(data.status){
    case 0:
        warning(data.message);
        break;
    case 1:

   
        agregar_titular_comite(agregar_comite).then(data => {
            

switch(data.status){
    case 2:
        success('Comite cargado exitosamente');
        window.location.href = `/login/${this.props.match.params.comite}/${this.props.match.params.num_comite}`;
    break;
        default:
            warning(data.data);
            break;
}

        });

        
        break;
    case 5:
        error('Error de Conexión');
        break;
}

              
            });

          }
        });
      };

    

      

      

    render() {

      if( this.props.match.params.num_comite < 1 || this.props.match.params.num_comite > 6 ){
       return(
         <p>Comité no encontrado</p>
       );
      }else{
        const { getFieldDecorator } = this.props.form;
    return (
      <Spin spinning={this.state.loading}>
      <Row>
         <Col span={8} offset={8} style={{ textAlign:'center' }}>
         <h1>{this.state.nombre_comite}</h1>
      <Form onSubmit={this.handleSubmit} style={{ textAlign:'center' }} className="login-form">
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Ingresa tu correo electrónico' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Correo electrónico"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Ingresa tu contraseña!' }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="Contraseña"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('codigo', {
            rules: [{ required: true }],
          })(
            <Input
              type="text"
              placeholder="Código de Empresa"
            />,
          )}
        </Form.Item>
        <Form.Item>
          
          <Button type="primary" htmlType="submit" className="login-form-button">
            Entrar
          </Button>
          <br />
          
          <Link to={`/registro/${this.props.match.params.comite}/${this.props.match.params.num_comite}`}> regresar</Link>
        </Form.Item>
      </Form>
      </Col>
      </Row>
      </Spin>
      );
      }

    
  }
}

const WrappedComponentForm = Form.create({ name: 'normal_login' })(FormLogin);

export default WrappedComponentForm;
